/* 馬超傳・第 3 章：潼關（中）離間（建安十六年，211）
 * 史實：《賈詡傳》曹操問計，賈詡答「離之而已」，又說「可偽許之」。
 *       《武帝紀》曹操和韓遂「交馬語移時，不及軍事，但說京都舊故，拊手歡笑」；
 *       「公又與遂書，多所點竄，如遂改定者；超等愈疑遂。」
 *       關西十部：韓遂、馬超、侯選、程銀、楊秋、李堪、張橫、梁興、成宜、馬玩（《武帝紀》）。
 * 這是第 3 章的第二幕（def.of，第一幕是交馬語 machao3a）。
 * 流程：聯軍營裡，韓遂和其他八部各有一條信任。交馬語、點竄過的信、營中的流言都會讓信任下滑；
 *       馬超可以到各部安撫（站定讀條），但安撫一位，另一位就更疑心。信任歸零的那一部就散了。
 *       撐到決戰前夕；照史實結局是「超等愈疑遂」。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, vanish } from '../kit.ts';
import { MEN, bar } from './machao_kit.ts';
import { XICAMP, EXIT } from '../maps/machao_weinan.ts';

const LV = 12, LEN = 100, CALM = 1.5, LEAVE_AT = 4; // 只剩 LEAVE_AT 部以下就瓦解
const BU = [['韓遂', MEN.hansui], ['侯選', MEN.yangqiu], ['程銀', MEN.likan], ['楊秋', MEN.yangqiu], ['李堪', MEN.likan], ['張橫', MEN.chengyi], ['梁興', MEN.liangxing], ['成宜', MEN.chengyi], ['馬玩', MEN.hansui]];

export default {
  id: 'machao-3', of: 'machao-3a', map: 'machao_weinan', hero: 'machao',
  title: '第 3 章　潼關（中）：交馬語・離間', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '公又與遂書，多所點竄，如遂改定者；超等愈疑遂。', src: '《三國志·魏書·武帝紀》' }],
    text: '會語之後，曹操問計於賈詡，賈詡說「離之而已」。曹操和韓遂只談京都舊事，又送來一封塗改過的信。聯軍各部開始互相猜疑。',
    goals: ['到各部營帳安撫將領，撐到決戰前夕'],
  },
  words: { ally: '關西十部', foe: '曹軍' },
  stars: [ // 兩幕合算
    { text: '會語：許褚一次都沒起疑', ok: (m) => !m.prev || !m.prev.vars.sus },
    { text: '決戰前有 6 部以上仍信任馬超', ok: (m) => (m.vars.loyal || 0) >= 6 },
    { text: '沒有一部散去', ok: (m) => m.vars.gone === 0 },
  ],
  steps: [
    { // 0. 離間
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = XICAMP[0]; me.y = XICAMP[1] + 100;
        V.t0 = w.t; V.gone = 0;
        V.bu = BU.map(([name, spec], i) => {
          const a = (i / BU.length) * Math.PI * 2, x = XICAMP[0] + Math.cos(a) * 620, y = XICAMP[1] + Math.sin(a) * 420;
          const u = ally(w, spec, x, y, LV - 2); u.name = name; u.hold = [u.x, u.y]; u.trust = 100;
          return u;
        });
        m.card('「離之而已。」', '《三國志·魏書·賈詡傳》');
        m.after(2, () => m.line('提示', '各部頭上是對聯軍的信任。走到將領身邊站定就能安撫（信任大升），但被冷落的其他部會更疑心。信任歸零的那一部就散了。'));
        // 事件：交馬語、點竄書、流言
        m.after(8, () => { m.card('交馬語移時，不及軍事，但說京都舊故，拊手歡笑。', '《武帝紀》'); m.line('侯選', '韓文約和曹操談了半天，都說了些什麼？'); drop(m, null, 18); });
        m.after(40, () => { m.card('公又與遂書，多所點竄，如遂改定者。', '《武帝紀》'); m.line('程銀', '這信怎麼塗塗改改的？韓遂在瞞什麼？'); drop(m, null, 18); });
        for (const t of [20, 30, 52, 64, 76, 88]) m.after(t, () => { const live = V.bu.filter((u) => !u.left), a = live[Math.floor(SG.rand() * live.length)], b = live[Math.floor(SG.rand() * live.length)]; if (a) { drop(m, a, 24); m.line(a.name, '聽說曹操要割地給韓遂……'); } if (b && b !== a) drop(m, b, 24); });
        m.obj('calm', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, left = LEN - (w.t - V.t0);
        for (const u of V.bu) if (!u.left) u.trust -= dt * 0.4;
        // 安撫：站在將領身邊不動
        for (const u of V.bu) if (!u.left && !me.chan && !(u.calmT > w.t) && m.chanAt(me, 'calm' + u.name, u.x, u.y, 170, CALM, '安撫' + u.name, () => {
          u.trust = Math.min(100, u.trust + 45); u.calmT = w.t + 8; m.line(u.name, '……孟起說得是。'); V.calmed = (V.calmed || 0) + 1; // 剛安撫過的，8 秒內不用再去
          const others = V.bu.filter((o) => o !== u && !o.left), o = others[Math.floor(SG.rand() * others.length)];
          if (o) { o.trust -= 6; w.dmgEvents.push({ x: o.x, y: o.y - 90, text: '疑心 -6', team: 1, src: o.id }); }
        })) break;
        for (const u of V.bu) if (!u.left && u.trust <= 0) { // 這一部散了
          u.left = true; V.gone++; u.hold = EXIT.slice(); m.line(u.name, '這仗沒法打了，回去！');
          m.after(8, () => vanish(w, u));
        }
        const stay = V.bu.filter((u) => !u.left).length;
        m.get('calm').text = `安撫各部（還在的 ${stay}/${BU.length} 部；${Math.max(0, Math.ceil(left))} 秒後決戰）`;
        if (stay < LEAVE_AT) { m.lose('聯軍瓦解，各部散去'); return false; }
        if (left > 0) return false;
        V.loyal = V.bu.filter((u) => !u.left && u.trust > 40).length;
        return true;
      },
    },
    { // 1. 超等愈疑遂
      enter(m) {
        m.done('calm');
        m.card('超等愈疑遂。', '《武帝紀》');
        m.after(3, () => m.line('馬超', `還有 ${m.vars.loyal} 部肯和我一起打。明日決戰！`));
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('馬超陣亡'); return; }
    for (const u of m.vars.bu || []) if (u.alive) allyTick(w, u, null, 0);
  },
  overlay(ctx, m) {
    for (const u of m.vars.bu || []) if (u.alive && !u.left) { const k = Math.max(0, u.trust) / 100; bar(ctx, u.x, u.y - 150, k, k > 0.4 ? '#7ac060' : k > 0.2 ? '#e0b040' : '#e05030', u.name); }
  },
};

// 信任下滑：u 是哪一部（null：全部）
function drop(m, u, n) {
  for (const o of u ? [u] : m.vars.bu) if (!o.left) { o.trust -= n; m.w.dmgEvents.push({ x: o.x, y: o.y - 90, text: `信任 -${n}`, team: 1, src: o.id }); }
}
